import { HospitalizationDto } from '@act/shared/data-transfer-objects';
import { Box, Typography } from '@mui/material';
import { DateTime } from 'luxon';
import { HtmlDisplayerWithHyperlinks } from 'react-components/components/HtmlDisplayerWithHyperlinks';
import { LinkFormatter } from 'utilities/formatters/link-formatter';
import { timeFormatter } from '@act/shared/utilities';
import { IconLibrary } from '@act/storybook';

interface LearnMoreHospitalizationProps {
  hospitalization: HospitalizationDto;
}

export const LearnMoreHospitalization = ({
  hospitalization,
}: LearnMoreHospitalizationProps) => {
  return (
    <div>
      <div className="info-section">
        <div className="info">
          <Typography variant="labelMedium" fontWeight="bold" component="p">
            Admitting Hospital
          </Typography>
          <Typography variant="bodyMedium" component="p">
            <a
              href={LinkFormatter.googleSearchUrl(hospitalization.hospital)}
              target="_blank"
            >
              {hospitalization.hospital}
            </a>
          </Typography>
        </div>
        {hospitalization.admitComplaint && (
          <div className="info">
            <Typography variant="labelMedium" fontWeight="bold" component="p">
              Admission Complaint
            </Typography>
            <Typography variant="bodyMedium" component="p">
              {hospitalization.admitComplaint}
            </Typography>
          </div>
        )}
        {hospitalization.admitDate && (
          <div className="info">
            <Typography variant="labelMedium" fontWeight="bold" component="p">
              Admit Date
            </Typography>
            <Typography variant="bodyMedium" component="p">
              {timeFormatter.epochToHumanReadableDate({
                date: DateTime.fromFormat(
                  hospitalization.admitDate,
                  'yyyy-MM-dd'
                ).toMillis(),
              })}
            </Typography>
          </div>
        )}
        {hospitalization.dischargeDate && (
          <div className="info">
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
              <Typography variant="labelMedium" fontWeight="bold" component="p">
                Discharge Date
              </Typography>
              {!hospitalization.isAssumed && (
                <IconLibrary iconName="SealCheck" />
              )}
            </Box>
            <Typography variant="bodyMedium" component="p">
              {timeFormatter.epochToHumanReadableDate({
                date: DateTime.fromFormat(
                  hospitalization.dischargeDate,
                  'yyyy-MM-dd'
                ).toMillis(),
              })}
            </Typography>
          </div>
        )}

        {/* Show only if followUpType is behavioral health */}
        {hospitalization.followUpType && (
          <div className="info">
            <Typography variant="labelMedium" fontWeight="bold" component="p">
              Enrolled in Behavioral Health
            </Typography>
            <Typography variant="bodyMedium" component="p">
              {hospitalization.isEnrolledInBehavioralHealth ? 'True' : 'False'}
            </Typography>
          </div>
        )}

        {hospitalization.expectedSurveyCompletion && (
          <div className="info">
            <Typography variant="labelMedium" fontWeight="bold" component="p">
              Expected Survey Completion
            </Typography>
            <Typography variant="bodyMedium" component="p">
              {timeFormatter.epochToHumanReadableDate({
                date: DateTime.fromFormat(
                  hospitalization.expectedSurveyCompletion,
                  'yyyy-MM-dd'
                ).toMillis(),
              })}
            </Typography>
          </div>
        )}
      </div>
      {hospitalization.note && (
        <div className="notes">
          <Typography variant="labelMedium" fontWeight="bold" component="h3">
            Notes
          </Typography>
          {HtmlDisplayerWithHyperlinks({
            note: hospitalization.note,
            displayMessage: 'Links in this note:',
          })}
        </div>
      )}
    </div>
  );
};
